<template>
  <div class="item-card">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'ItemCard'
  }
</script>

<style lang="scss" scoped>
  $basic-height: 1039px;
  $basic-width: 750px;
  $gold-height: 1181px;
  $gold-width: 768px;

  @mixin card ($basic-height: 1039px, $basic-width: 750px, $padding: 16px) {
    height: $basic-height;
    max-height: $basic-height;
    max-width: $basic-width;
    min-height: $basic-height;
    min-width: $basic-width;
    padding: $padding;
    width: $basic-width;
  }

  .item-card {
    @include card;
    background-color: #000;
    font-family: "Scaly Sans" !important;
    position: relative;

    & + .item-card {
      margin-left: 4px;
    }

    &.gold-card {
      @include card($gold-height, $gold-width);
    }
  }
</style>